import { render, staticRenderFns } from "./deviceTelemetryValues.vue?vue&type=template&id=08a12629&scoped=true&"
import script from "./deviceTelemetryValues.vue?vue&type=script&lang=js&"
export * from "./deviceTelemetryValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a12629",
  null
  
)

export default component.exports